<template>
    <div class="container-fluid bg-white rounded">
        <div class="container cprimary p-3" v-if="contentText && type == `briefingDetail`">
            <b-row>
                <b-col class="text-center p-3 mb-3 mt-3">
                    <h3>{{ contentText.title }}</h3>
                </b-col>
                
            </b-row>
            <!-- <b-row>
                <b-col class="text-left">时间：{{ contentText.create_time }}</b-col>
            </b-row> -->
            <b-row>
                <b-col class="text-left p-3">
                    <div v-html="contentText.content">
                        <!-- {{ item.content }} -->
                    </div>
                    <!-- <b-img :src="`https://api.100xsys.cn/file/download?fileNo=${item.icon_image}&bx_auth_ticket=${token}`" fluid-grow alt="Fluid-grow image"></b-img> -->
                </b-col>
                
            </b-row>

            
        </div>
        <div class="container cprimary p-3" v-if="contentText && type == `policyDetail`">
            <b-row class=" p-3">
                <b-col class="text-center p-3 mb-3 mt-3">
                    <h3>{{ contentText.policy_title }}</h3>
                </b-col>
                
            </b-row>
            <b-row class=" p-3 border border-cBorder">
                <b-col cols="4" class="text-left">发布时间：{{ contentText.publication_date }}</b-col>
                <b-col cols="4" class="text-center">发布部门：{{ contentText.policy_sources_unit_name }}</b-col>
                <b-col cols="4" class="text-right">截止时间：{{ contentText.end_date }} 
                    <b-badge v-if="contentText.progress_state == '进行中'" pill variant="primary">{{contentText.progress_state}}</b-badge>
                    <b-badge v-if="contentText.progress_state == '已结束'" pill variant="danger">{{contentText.progress_state}}</b-badge>
                </b-col>
                <b-col cols="12" class="text-left">支持方式：{{ contentText.support_mode }}</b-col>
                <b-col  cols="12" class="text-left text-bold">产业关键词：{{ contentText.policy_industry }}</b-col>
                <b-col cols="12"  v-if="contentText.maximum_amount" class="text-right"><span >最高奖金(万)：{{ contentText.maximum_amount }}万元</span></b-col>
                
            </b-row>
            <b-row class=" p-3 bg-cgray  rounded-lg border-cBorder">
                <b-col cols="12" class="text-left">
                    <p v-html="`${contentText.declaration_cond}`.replace(/\n/g,'<br/>')">
                        <!-- {{ item.content }} -->
                    </p>
                </b-col>
                <b-col cols="12"  class="text-left p-3">
                    <p v-html="`${contentText.subsidy_standard}`.replace(/\n/g,'<br/>')">
                        <!-- {{ item.content }} -->
                    </p>
                </b-col>
                <b-col cols="12"  class="text-left p-3">
                    <p v-html="`${contentText.policy_basis}`.replace(/\n/g,'<br/>')">
                        <!-- {{ item.content }} -->
                    </p>
                </b-col>
            </b-row>

            
        </div>
        <div class="container cprimary p-3" v-if="contentText && type == `mediaDetails` && mediaDetails">
            <div clsss="p-3  rounded-lg border border-cBorder">
                <b-row class=" p-3">
                <b-col class="text-center p-3 mb-3 mt-3">
                    <h2>{{ mediaDetails.title }}</h2>
                    </b-col>
                </b-row>
                <b-row class=" p-3 ">
                    <b-col cols="6" class="text-right">发布时间：{{ mediaDetails.create_time }}</b-col>
                    <!-- <b-col cols="4" class="text-right">发布人：{{ mediaDetails.create_user_disp }}</b-col> -->
                    <b-col cols="6" class="text-left">发布人：{{ `易企跑` }}</b-col>
                </b-row>
            </div>
            
            <b-row class=" p-3  rounded-lg border border-cBorder">
                <b-col cols="12" class="text-left">
                    <p v-html="`${mediaDetails.content}`.replace(/\n/g,'<br/>')">
                    </p>
                </b-col>
            </b-row>

            
        </div>
    </div>
  </template>
  
  <script>
//   import qrCode from '@/assets/qrCode.png'
  import xiaochengxu from '@/assets/xiaochengxu.png'
  import gongzhonghao from '@/assets/gongzhonghao.png'

  import { getListData } from '@/api/api.js'
  export default {
    name: 'detail-layout',
    props: {
        type:{
            type:String,
            default(){
                return 'text'  // text   map   list
            }
        },
        config:{
            type:[Object,Array],
            default(){
                return null
             
            }
        }
    },
    mounted(){
        // this.getFriendLinks() 
        if(this.type == `mediaDetails` && this.contentText){
            this.getDetail(this.contentText)
        } 
        
    },
    computed:{
        contentText(){
            let text = this.$route.params.body || null
            if(this.type !== `mediaDetails` && text){
                text = JSON.parse(text)
            }
            return text
        }
    },
    data() {
      return {
        provinceName:"",
        gongzhonghaoImg:gongzhonghao,
        xiaochengxuImg:xiaochengxu,
        mediaDetails:null
      }
    },
      methods: {
        getDetail(no){
            let req = {
                "serviceName": "srvdaq_cms_content_lunbo_select",
                "colNames": [
                    "*"
                ],
                "condition": [
                    {
                        "colName": "content_no",
                        "ruleType": "eq",
                        "value": no
                    }
                ],
                "page": {
                    "pageNo": 1,
                    "rownumber": 999
                },
                "order": [{"colName":"seq","orderType":"asc"}]
            }
            getListData (req,'daq','srvdaq_cms_content_lunbo_select').then(res=>{
                console.log(res)
                if(res.state == "SUCCESS"){
                    let content = res.data[0]
                    this.$set(this,'mediaDetails',content)
                }
            })
        }
    },
    watch:{
        "contentText":{
            deep:true,
            handler:function(nval,oval){
                // console.log(nval,oval)
                if(this.type == `mediaDetails` && this.contentText){
                    this.getDetail(this.contentText)
                } 
            }
        },
    }
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>

  </style>
  